import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WalkFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.1547 6.73587C13.3519 6.73587 14.3224 5.76534 14.3224 4.56813C14.3224 3.37092 13.3519 2.40039 12.1547 2.40039C10.9575 2.40039 9.98694 3.37092 9.98694 4.56813C9.98694 5.76534 10.9575 6.73587 12.1547 6.73587ZM11.4925 7.97461L7.86235 10.9997L7.53851 11.2696V11.6911V14.1686H9.33851V12.1127L11.2546 10.5159V14.7879V15.1607L11.5182 15.4243L14.3514 18.2575V21.6008H16.1514V17.8847V17.5119L15.8878 17.2483L13.0546 14.4151V8.59436V7.97461H11.4925ZM16.4731 14.8043L14.8198 13.151V10.6054L17.7459 13.5315L16.4731 14.8043ZM10.2796 16.6284L6.56348 20.3445L7.83627 21.6173L11.5524 17.9012L10.2796 16.6284Z"
      />
    </SvgIcon>
  );
});
